<template>
  <div class="lotteryPanel">
    <div class="broadcast" v-if="winnerList.length > 0">
      <Rolling clipTime="2000">
        <div class="broadcastItem" v-for="item in winnerList" :key="item.id">
          {{ item.content }}
        </div>
      </Rolling>
    </div>
    <div class="leftChanceNote">
      <div>
        您还有
        <span class="chanceHighlight">{{ lotteryTicketCount }}</span> 次抽奖机会
      </div>
    </div>
    <div class="lottery" @click.capture="handleLotteryOutterClick">
      <TurnplateLottery
        :lotterySetting="$attrs"
        :lotteryAwards="actData.rewards"
        :lotteryResult="lotteryResult"
        @fire="handleDraw"
        @lotteryFinish="handleLotteryFinish"
        @noTicket="handleNoTicket"
        @reportDraw="handleReportDraw"
        :lotteryTicketCount="lotteryTicketCount"
      />
    </div>
    <WinModal
      :visible="isShowWinModal"
      :awardData="resultAwardsData"
      @close="handleCloseWinModal"
    ></WinModal>
    <NoPrizeModal
      :visible="isShowNoPrizeModal"
      @close="handleCloseNoPrizeModal"
    ></NoPrizeModal>
  </div>
</template>

<script>
import Rolling from '@/components/UI/Rolling';
import WinModal from './WinModal';
import NoPrizeModal from '@/components/templates/common/NoPrizeModal';
import TurnplateLottery from '@/components/templates/common/TurnplateLottery';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  components: { Rolling, TurnplateLottery, WinModal, NoPrizeModal },
  props: {
    componentTypeId: Number,
    moduleName: String,
    toastText: String
  },
  computed: {
    ...mapState('app', {
      actData: function(state) {
        return state[this.moduleName].actData;
      },
      tplData: function(state) {
        return state[this.moduleName].tplData;
      },
      isShowWinModal: function(state) {
        return state[this.moduleName].isShowWinModal;
      },
      isShowNoPrizeModal: function(state) {
        return state[this.moduleName].isShowNoPrizeModal;
      },
      lotteryResult: function(state) {
        return state[this.moduleName].lotteryResult;
      }
    }),
    winnerList() {
      return this.actData && this.actData.message ? this.actData.message : [];
    },
    lotteryTicketCount() {
      return this.actData.remainTimes;
    },
    resultAwardsData() {
      if (this.lotteryResult && this.lotteryResult.length) {
        const award = this.lotteryResult[0];
        if (award.rewardType === 'REWARD_PACKAGE') {
          return {
            name: award.rewardName,
            awards: award.parsedUserRewardInfos
          };
        }
        return {
          name: award.rewardName,
          awards: [award]
        };
      }
      return {};
    }
  },
  mounted() {
    this.reportExpo();
  },
  methods: {
    ...mapActions('app', {
      submitDraw: function(dispatch) {
        dispatch(`${this.moduleName}/submitDraw`);
      },
      showLotteryResult: function(dispatch) {
        dispatch(`${this.moduleName}/showLotteryResult`);
      },
      actTimeCheck: function(dispatch) {
        return dispatch(`${this.moduleName}/actTimeCheck`);
      }
    }),
    ...mapMutations('app', {
      toggleWinModal: function(commit, ...props) {
        commit(`${this.moduleName}/toggleWinModal`, ...props);
      },
      toggleNoPrizeModal: function(commit, ...props) {
        commit(`${this.moduleName}/toggleNoPrizeModal`, ...props);
      },
      resetLotteryResult: function(commit) {
        commit(`${this.moduleName}/resetLotteryResult`);
      }
    }),
    async handleLotteryOutterClick(e) {
      const isBetweenActTime = await this.actTimeCheck();
      if (!isBetweenActTime) {
        e.stopPropagation();
      }
    },
    async handleDraw() {
      this.submitDraw();
    },
    handleLotteryFinish() {
      this.showLotteryResult();
    },
    handleCloseWinModal() {
      this.toggleWinModal(false);
      this.resetLotteryResult();
    },
    handleCloseNoPrizeModal() {
      this.toggleNoPrizeModal(false);
      this.resetLotteryResult();
    },
    handleNoTicket() {
      this.$hll.toast(this.toastText || '没有抽奖机会了');
    },
    reportExpo() {
      this.$emit('reportEvent', {
        event: 'enterprise_points_expo',
        module_name: '抽奖模块：大转盘'
      });
    },
    handleReportDraw() {
      this.$emit('reportEvent', {
        event: 'enterprise_points_click',
        module_name: '抽奖模块:大转盘',
        button_name: '大转盘'
      });
    }
  }
};
</script>

<style lang="less" scoped>
.lotteryPanel {
  position: relative;
  overflow: hidden;
  text-align: center;

  .lottery {
    margin-top: 184px;
    margin-bottom: 71px;
  }

  .broadcast {
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 24px;
    color: #fff;

    .broadcastItem {
      width: 550px;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .leftChanceNote {
    position: absolute;
    top: 105px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 28px;
    color: #333;
    line-height: 1;

    .chanceHighlight {
      color: #ff0b0b;
    }
  }
}
</style>
